import React, { Component, ErrorInfo, ReactNode } from 'react'
import { Alert } from 'antd'

interface ErrorBoundaryProps {
    children: ReactNode
    fallback?: ReactNode
}

interface ErrorBoundaryState {
    hasError: boolean
    error?: Error
}

/**
 * ErrorBoundary component
 * Catches JavaScript errors anywhere in the child component tree and displays a fallback UI
 */
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        // Update state so the next render will show the fallback UI
        return { hasError: true, error }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // Log error to console for debugging
        console.error('FieldSuggestionResultsManager Error:', error, errorInfo)
    }

    render() {
        if (this.state.hasError) {
            // Render custom fallback UI or default error message
            return (
                this.props.fallback || (
                    <Alert
                        type="error"
                        showIcon
                        message="Something went wrong"
                        description="An error occurred while loading the field suggestions. Please try again."
                        style={{ margin: 16 }}
                    />
                )
            )
        }

        return this.props.children
    }
}
